/* eslint-disable react-hooks/exhaustive-deps */
// src/components/Reporte3.js

import React, {
  useEffect,
  useRef,
  useState,
  useContext,
} from "react";

import moment from "moment";

import {
  Container,
  Segment,
  Table,
  Grid,
  Header,
  Icon,
  Label,
  Message,
} from "semantic-ui-react";

import { AiFillCheckCircle } from "react-icons/ai";

import {
  collection,
  getDocs,
  where,
  query,
} from "firebase/firestore";

import { db } from "../firebase/firebaseConfig";
import { UserContext } from "../context/UserContext";

import Alerta from "./Alertas";
import BuscadorInput from "./BuscadorInput";

/* =====================================================
   ESTILOS
===================================================== */

const stickyTh = {
  position: "sticky",
  top: 0,
  zIndex: 2,
  background: "#f8fafc",
  color: "#42526e",
  fontSize: 11,
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: 0.3,
  whiteSpace: "nowrap",
};

/* =====================================================
   COMPONENTE
===================================================== */

const Reporte3 = () => {
  const { users } = useContext(UserContext);

  /* =====================================================
     ESTADOS
  ===================================================== */

  const [alerta, cambiarAlerta] = useState({});
  const [estadoAlerta, cambiarEstadoAlerta] =
    useState(false);

  const [rut, setRut] = useState("");
  const [entidad, setEntidad] = useState("");

  const [proveedores, setProveedores] =
    useState([]);

  const [merges, setMerges] = useState([]);

  const [loadingPacientes, setLoadingPacientes] =
    useState(false);

  const [loadingMovimientos, setLoadingMovimientos] =
    useState(false);

  // Si no lo usas, mantener fijo
  const confirmar = false;

  // refs
  const ent = useRef([]);
  const sal = useRef([]);

  /* =====================================================
     CARGAR PACIENTES
  ===================================================== */

  const obtenerProveedores = async () => {
    if (!users?.emp_id) {
      setProveedores([]);
      return;
    }

    setLoadingPacientes(true);

    try {
      const datosProveedores = query(
        collection(db, "clientes"),
        where("emp_id", "==", users.emp_id)
      );

      const dataProveedores =
        await getDocs(datosProveedores);

      const arrayProveedores =
        dataProveedores.docs
          .map((d) => ({
            ...d.data(),
            id: d.id,
          }))
          .sort((a, b) =>
            String(a.nombre || "").localeCompare(
              String(b.nombre || ""),
              "es",
              {
                sensitivity: "base",
              }
            )
          );

      setProveedores(arrayProveedores);
    } catch (err) {
      console.error(
        "Error cargando pacientes:",
        err
      );

      setProveedores([]);

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje: "Error cargando pacientes.",
      });
    } finally {
      setLoadingPacientes(false);
    }
  };

  /* =====================================================
     HELPERS ENTRADA / SALIDA
     DESDE LA PERSPECTIVA DEL PACIENTE
  ===================================================== */

  const normalizarMovimiento = (valor) => {
    return String(valor || "")
      .trim()
      .toUpperCase();
  };

  const esEntradaPaciente = (item) => {
    const mov = normalizarMovimiento(
      item.tipoinout
    );

    const tipdoc = normalizarMovimiento(
      item.tipdoc
    );

    /* ==========================================
       TRASPASOS
       ST -> PACIENTE = ENTRADA AL PACIENTE
    ========================================== */

    if (tipdoc === "TRASPASOS") {
      return (
        mov.includes("A PACIENTE") &&
        !mov.startsWith("PACIENTE")
      );
    }

    /* ==========================================
       MOVIMIENTOS NORMALES
       BODEGA -> PACIENTE
    ========================================== */

    if (mov === "PACIENTE") {
      return true;
    }

    if (
      mov.includes("BODEGA A PACIENTE")
    ) {
      return true;
    }

    return false;
  };

  const esSalidaPaciente = (item) => {
    const mov = normalizarMovimiento(
      item.tipoinout
    );

    const tipdoc = normalizarMovimiento(
      item.tipdoc
    );

    /* ==========================================
       TRASPASOS
       PACIENTE -> ST = SALIDA DEL PACIENTE
    ========================================== */

    if (tipdoc === "TRASPASOS") {
      return mov.startsWith("PACIENTE A");
    }

    /* ==========================================
       RETORNO NORMAL
       PACIENTE -> BODEGA
    ========================================== */

    if (
      mov.includes("PACIENTE A BODEGA")
    ) {
      return true;
    }

    if (
      mov.includes("RETIRO PACIENTE")
    ) {
      return true;
    }

    return false;
  };

  /* =====================================================
     BUSCAR MOVIMIENTOS POR RUT
  ===================================================== */

  const buscarMovimientosPorRut =
    async (rutSeleccionado) => {
      if (
        !users?.emp_id ||
        !rutSeleccionado
      ) {
        return;
      }

      cambiarEstadoAlerta(false);
      cambiarAlerta({});

      setLoadingMovimientos(true);

      try {
        /* ======================================
           ENTRADAS
        ====================================== */

        const qE = query(
          collection(db, "entradas"),
          where(
            "emp_id",
            "==",
            users.emp_id
          ),
          where(
            "rut",
            "==",
            rutSeleccionado
          )
        );

        /* ======================================
           SALIDAS
        ====================================== */

        const qS = query(
          collection(db, "salidas"),
          where(
            "emp_id",
            "==",
            users.emp_id
          ),
          where(
            "rut",
            "==",
            rutSeleccionado
          )
        );

        const [dataE, dataS] =
          await Promise.all([
            getDocs(qE),
            getDocs(qS),
          ]);

        ent.current =
          dataE.docs.map((d) => ({
            ...d.data(),
            id: d.id,
            origenColeccion: "ENTRADA",
          }));

        sal.current =
          dataS.docs.map((d) => ({
            ...d.data(),
            id: d.id,
            origenColeccion: "SALIDA",
          }));

        /* ======================================
           MERGE
        ====================================== */

        const merged = [
          ...ent.current,
          ...sal.current,
        ]
          /*
           * Mantenemos tu lógica actual.
           * tipmov 0 sigue excluido hasta
           * que revisemos qué representa.
           */
          .filter(
            (mov) =>
              Number(mov.tipmov) !== 0
          )

          /* Orden cronológico */
          .sort((a, b) => {
            const fechaA =
              a?.date?.toMillis?.() || 0;

            const fechaB =
              b?.date?.toMillis?.() || 0;

            return fechaA - fechaB;
          })

          .map((mov, idx) => ({
            ...mov,
            id2: idx + 1,
          }));

        setMerges(merged);

        if (merged.length === 0) {
          cambiarEstadoAlerta(true);

          cambiarAlerta({
            tipo: "info",
            mensaje:
              "Este paciente no registra movimientos.",
          });
        }
      } catch (err) {
        console.error(
          "Error obteniendo movimientos:",
          err
        );

        setMerges([]);

        cambiarEstadoAlerta(true);

        cambiarAlerta({
          tipo: "error",
          mensaje:
            "Error al obtener movimientos del paciente.",
        });
      } finally {
        setLoadingMovimientos(false);
      }
    };

  /* =====================================================
     SELECCIÓN PACIENTE
  ===================================================== */

  const handleSelectItem = (item) => {
    if (
      !item ||
      typeof item !== "object"
    ) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Debes seleccionar un paciente del listado.",
      });

      return;
    }

    setRut(item.rut || "");

    setEntidad(item.nombre || "");

    buscarMovimientosPorRut(
      item.rut
    );
  };

  /* =====================================================
     LIMPIAR
  ===================================================== */

  const limpiaFormCte = () => {
    setRut("");
    setEntidad("");
    setMerges([]);

    ent.current = [];
    sal.current = [];

    cambiarEstadoAlerta(false);
    cambiarAlerta({});
  };

  /* =====================================================
     FORMATO FECHA
  ===================================================== */

  const formatearFecha = (fecha) => {
    if (!fecha) {
      return "";
    }

    if (fecha?.toDate) {
      return moment(
        fecha.toDate()
      ).format(
        "DD/MM/YYYY HH:mm"
      );
    }

    const fechaMoment =
      moment(fecha);

    return fechaMoment.isValid()
      ? fechaMoment.format(
          "DD/MM/YYYY HH:mm"
        )
      : "";
  };

  /* =====================================================
     CARGA INICIAL
  ===================================================== */

  useEffect(() => {
    obtenerProveedores();
  }, [users?.emp_id]);

  /* =====================================================
     ICONO MOVIMIENTO
  ===================================================== */

  const renderEstadoMovimiento = (
    item,
    tipo
  ) => {
    const enTransito =
      Number(item.historial) === 0;

    const colorFinal =
      tipo === "ENTRADA"
        ? "#21ba45"
        : "#f2711c";

    return (
      <AiFillCheckCircle
        style={{
          color: enTransito
            ? "#fbbd08"
            : colorFinal,
          fontSize: 19,
        }}
        title={
          enTransito
            ? "En tránsito"
            : "Finalizado"
        }
      />
    );
  };

  /* =====================================================
     CONTADORES
  ===================================================== */

  const totalEntradas =
    merges.filter(
      esEntradaPaciente
    ).length;

  const totalSalidas =
    merges.filter(
      esSalidaPaciente
    ).length;

  /* =====================================================
     TABLA
  ===================================================== */

  const renderTabla = () => (
    <div
      style={{
        overflowX: "auto",
        maxHeight: 560,
      }}
    >
      <Table
        celled
        compact
        selectable
        unstackable
        style={{
          margin: 0,
          minWidth: 1100,
          border: 0,
          borderRadius: 0,
        }}
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              style={stickyTh}
              textAlign="center"
            >
              #
            </Table.HeaderCell>

            <Table.HeaderCell
              style={stickyTh}
            >
              Fecha
            </Table.HeaderCell>

            <Table.HeaderCell
              style={stickyTh}
            >
              Documento
            </Table.HeaderCell>

            <Table.HeaderCell
              style={stickyTh}
            >
              Equipo
            </Table.HeaderCell>

            <Table.HeaderCell
              style={stickyTh}
            >
              Serie
            </Table.HeaderCell>

            <Table.HeaderCell
              style={stickyTh}
              textAlign="center"
            >
              <Icon
                name="sign-in"
                style={{
                  color: "#21ba45",
                  margin: 0,
                }}
                title="Entrada al paciente"
              />
            </Table.HeaderCell>

            <Table.HeaderCell
              style={stickyTh}
              textAlign="center"
            >
              <Icon
                name="sign-out"
                style={{
                  color: "#f2711c",
                  margin: 0,
                }}
                title="Salida desde el paciente"
              />
            </Table.HeaderCell>

            <Table.HeaderCell
              style={stickyTh}
            >
              Tipo Mov.
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {merges.map(
            (item, index) => (
              <Table.Row
                key={`${item.origenColeccion}-${item.id}-${index}`}
              >
                <Table.Cell
                  textAlign="center"
                  style={{
                    color: "#6b778c",
                  }}
                >
                  {index + 1}
                </Table.Cell>

                <Table.Cell
                  style={{
                    whiteSpace:
                      "nowrap",
                  }}
                >
                  <Icon
                    name="clock outline"
                    style={{
                      color: "#98a1af",
                    }}
                  />

                  {formatearFecha(
                    item.date
                  ) || "—"}
                </Table.Cell>

                <Table.Cell>
                  <Label
                    basic
                    size="tiny"
                    style={{
                      margin: 0,
                    }}
                  >
                    {item.tipdoc || "—"}
                  </Label>

                  <span
                    style={{
                      marginLeft: 6,
                      color: "#42526e",
                    }}
                  >
                    {item.numdoc || ""}
                  </span>
                </Table.Cell>

                <Table.Cell>
                  <div
                    style={{
                      fontWeight: 700,
                      color: "#172b4d",
                    }}
                  >
                    {item.tipo ||
                      "Equipo"}
                  </div>

                  <div
                    style={{
                      fontSize: 11,
                      color: "#8793a5",
                      marginTop: 2,
                    }}
                  >
                    {[
                      item.marca,
                      item.modelo,
                    ]
                      .filter(Boolean)
                      .join(" ") || "—"}
                  </div>
                </Table.Cell>

                <Table.Cell
                  style={{
                    whiteSpace:
                      "nowrap",
                  }}
                >
                  {item.serie || "—"}
                </Table.Cell>

                {/* ENTRADA AL PACIENTE */}

                <Table.Cell
                  textAlign="center"
                >
                  {esEntradaPaciente(
                    item
                  ) ? (
                    renderEstadoMovimiento(
                      item,
                      "ENTRADA"
                    )
                  ) : (
                    <span
                      style={{
                        color: "#c1c7d0",
                      }}
                    >
                      —
                    </span>
                  )}
                </Table.Cell>

                {/* SALIDA DESDE PACIENTE */}

                <Table.Cell
                  textAlign="center"
                >
                  {esSalidaPaciente(
                    item
                  ) ? (
                    renderEstadoMovimiento(
                      item,
                      "SALIDA"
                    )
                  ) : (
                    <span
                      style={{
                        color: "#c1c7d0",
                      }}
                    >
                      —
                    </span>
                  )}
                </Table.Cell>

                <Table.Cell
                  style={{
                    whiteSpace:
                      "normal",
                    wordBreak:
                      "break-word",
                    minWidth: 220,
                  }}
                >
                  <div
                    style={{
                      color: "#42526e",
                    }}
                  >
                    {item.tipoinout ||
                      "—"}
                  </div>

                  {normalizarMovimiento(
                    item.tipdoc
                  ) ===
                    "TRASPASOS" && (
                    <Label
                      basic
                      size="mini"
                      color="blue"
                      style={{
                        marginTop: 5,
                      }}
                    >
                      <Icon name="exchange" />
                      Traspaso
                    </Label>
                  )}
                </Table.Cell>
              </Table.Row>
            )
          )}

          {!loadingMovimientos &&
            merges.length === 0 && (
              <Table.Row>
                <Table.Cell
                  colSpan={8}
                  textAlign="center"
                >
                  <div
                    style={{
                      padding:
                        "34px 15px",
                      color: "#8793a5",
                    }}
                  >
                    <Icon
                      name={
                        rut
                          ? "history"
                          : "search"
                      }
                      size="big"
                      style={{
                        color: "#c1c7d0",
                        marginBottom: 8,
                      }}
                    />

                    <div
                      style={{
                        color: "#42526e",
                        fontWeight: 600,
                        marginTop: 8,
                      }}
                    >
                      {rut
                        ? "Sin movimientos"
                        : "Seleccione un paciente"}
                    </div>

                    <div
                      style={{
                        fontSize: 12,
                        marginTop: 4,
                      }}
                    >
                      {rut
                        ? "Este paciente no registra movimientos para mostrar."
                        : "Busque por RUT o nombre para consultar el historial."}
                    </div>
                  </div>
                </Table.Cell>
              </Table.Row>
            )}
        </Table.Body>
      </Table>
    </div>
  );

  /* =====================================================
     RETURN
  ===================================================== */

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        paddingBottom: 40,
      }}
    >
      <Container
        fluid
        style={{
          maxWidth: 1400,
          margin: "0 auto",
          padding: "20px 16px",
        }}
      >
        {/* =====================================
            CABECERA
        ===================================== */}

        <div
          style={{
            display: "flex",
            justifyContent:
              "space-between",
            alignItems: "center",
            gap: 15,
            flexWrap: "wrap",
            marginBottom: 18,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 13,
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                minWidth: 48,
                borderRadius: 9,
                background: "#e5f7f7",
                display: "flex",
                justifyContent:
                  "center",
                alignItems: "center",
              }}
            >
              <Icon
                name="users"
                style={{
                  margin: 0,
                  color: "#0d9da5",
                  fontSize: 21,
                }}
              />
            </div>

            <div>
              <Header
                as="h2"
                style={{
                  margin: 0,
                  color: "#172b4d",
                  fontSize: 22,
                  fontWeight: 700,
                }}
              >
                Historial por Paciente
              </Header>

              <div
                style={{
                  marginTop: 3,
                  color: "#8793a5",
                  fontSize: 12,
                }}
              >
                Consulte las entradas y
                salidas de equipos desde la
                perspectiva del paciente.
              </div>
            </div>
          </div>
        </div>

        {/* =====================================
            BUSCADOR
        ===================================== */}

        <Segment
          style={{
            padding: 0,
            borderRadius: 8,
            border:
              "1px solid #e5e9ef",
            boxShadow:
              "0 1px 3px rgba(9,30,66,0.08)",
            overflow: "visible",
            marginBottom: 18,
          }}
        >
          {/* HEADER CARD */}

          <div
            style={{
              padding: "13px 17px",
              borderBottom:
                "1px solid #e5e9ef",
              display: "flex",
              justifyContent:
                "space-between",
              alignItems: "center",
              gap: 10,
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                color: "#253858",
                fontWeight: 700,
              }}
            >
              <Icon
                name="search"
                style={{
                  color: "#0d9da5",
                }}
              />

              Buscar paciente
            </div>

            {rut && (
              <Label
                size="small"
                style={{
                  margin: 0,
                  background:
                    "#e5f7f7",
                  color: "#0d9da5",
                }}
              >
                <Icon name="check circle" />

                Paciente seleccionado
              </Label>
            )}
          </div>

          {/* BODY */}

          <div
            style={{
              padding: 17,
            }}
          >
            <Grid
              stackable
              verticalAlign="middle"
            >
              <Grid.Row>
                <Grid.Column
                  computer={10}
                  tablet={10}
                  mobile={16}
                >
                  <div
                    style={{
                      fontSize: 11,
                      color: "#6b778c",
                      fontWeight: 600,
                      marginBottom: 6,
                    }}
                  >
                    RUT o nombre
                  </div>

                  <BuscadorInput
                    items={proveedores}
                    onSelectItem={
                      handleSelectItem
                    }
                    limpiaFormCte={
                      limpiaFormCte
                    }
                    confirmar={
                      confirmar
                    }
                    rut={rut}
                  />

                  <div
                    style={{
                      fontSize: 11,
                      color: "#98a1af",
                      marginTop: 6,
                    }}
                  >
                    <Icon name="info circle" />

                    Escriba el RUT o nombre
                    del paciente y
                    selecciónelo desde el
                    listado.
                  </div>
                </Grid.Column>

                <Grid.Column
                  computer={6}
                  tablet={6}
                  mobile={16}
                >
                  <div
                    style={{
                      background: "#f8fafc",
                      border:
                        "1px solid #e5e9ef",
                      borderRadius: 7,
                      padding:
                        "11px 13px",
                      minHeight: 62,
                      display: "flex",
                      alignItems:
                        "center",
                    }}
                  >
                    {rut ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems:
                            "center",
                          gap: 10,
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            width: 36,
                            height: 36,
                            minWidth: 36,
                            borderRadius:
                              7,
                            background:
                              "#e5f7f7",
                            display:
                              "flex",
                            justifyContent:
                              "center",
                            alignItems:
                              "center",
                          }}
                        >
                          <Icon
                            name="user"
                            style={{
                              margin: 0,
                              color:
                                "#0d9da5",
                            }}
                          />
                        </div>

                        <div
                          style={{
                            minWidth: 0,
                          }}
                        >
                          <div
                            style={{
                              color:
                                "#172b4d",
                              fontWeight:
                                700,
                              fontSize: 14,
                              overflow:
                                "hidden",
                              textOverflow:
                                "ellipsis",
                              whiteSpace:
                                "nowrap",
                            }}
                          >
                            {entidad ||
                              "Paciente"}
                          </div>

                          <div
                            style={{
                              color:
                                "#6b778c",
                              fontSize: 11,
                              marginTop: 3,
                            }}
                          >
                            RUT:{" "}
                            <strong>
                              {rut}
                            </strong>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          color:
                            "#8793a5",
                          fontSize: 12,
                          display:
                            "flex",
                          alignItems:
                            "center",
                          gap: 7,
                        }}
                      >
                        <Icon name="user outline" />

                        {loadingPacientes
                          ? "Cargando pacientes..."
                          : "Sin paciente seleccionado"}
                      </div>
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Segment>

        {/* =====================================
            KPIs
        ===================================== */}

        {rut && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(180px, 1fr))",
              gap: 12,
              marginBottom: 18,
            }}
          >
            {/* TOTAL */}

            <Segment
              style={{
                margin: 0,
                border:
                  "1px solid #e5e9ef",
                borderRadius: 8,
                boxShadow:
                  "0 1px 3px rgba(9,30,66,0.06)",
                padding:
                  "14px 16px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems:
                    "center",
                  justifyContent:
                    "space-between",
                  gap: 10,
                }}
              >
                <div>
                  <div
                    style={{
                      color:
                        "#8793a5",
                      fontSize: 11,
                      fontWeight:
                        600,
                      textTransform:
                        "uppercase",
                    }}
                  >
                    Movimientos
                  </div>

                  <div
                    style={{
                      color:
                        "#172b4d",
                      fontSize: 22,
                      fontWeight:
                        700,
                      marginTop: 3,
                    }}
                  >
                    {merges.length}
                  </div>
                </div>

                <Icon
                  name="exchange"
                  style={{
                    color:
                      "#2185d0",
                    fontSize: 22,
                  }}
                />
              </div>
            </Segment>

            {/* ENTRADAS */}

            <Segment
              style={{
                margin: 0,
                border:
                  "1px solid #e5e9ef",
                borderRadius: 8,
                boxShadow:
                  "0 1px 3px rgba(9,30,66,0.06)",
                padding:
                  "14px 16px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems:
                    "center",
                  justifyContent:
                    "space-between",
                  gap: 10,
                }}
              >
                <div>
                  <div
                    style={{
                      color:
                        "#8793a5",
                      fontSize: 11,
                      fontWeight:
                        600,
                      textTransform:
                        "uppercase",
                    }}
                  >
                    Entradas
                  </div>

                  <div
                    style={{
                      color:
                        "#172b4d",
                      fontSize: 22,
                      fontWeight:
                        700,
                      marginTop: 3,
                    }}
                  >
                    {totalEntradas}
                  </div>
                </div>

                <Icon
                  name="sign-in"
                  style={{
                    color:
                      "#21ba45",
                    fontSize: 22,
                  }}
                />
              </div>
            </Segment>

            {/* SALIDAS */}

            <Segment
              style={{
                margin: 0,
                border:
                  "1px solid #e5e9ef",
                borderRadius: 8,
                boxShadow:
                  "0 1px 3px rgba(9,30,66,0.06)",
                padding:
                  "14px 16px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems:
                    "center",
                  justifyContent:
                    "space-between",
                  gap: 10,
                }}
              >
                <div>
                  <div
                    style={{
                      color:
                        "#8793a5",
                      fontSize: 11,
                      fontWeight:
                        600,
                      textTransform:
                        "uppercase",
                    }}
                  >
                    Salidas
                  </div>

                  <div
                    style={{
                      color:
                        "#172b4d",
                      fontSize: 22,
                      fontWeight:
                        700,
                      marginTop: 3,
                    }}
                  >
                    {totalSalidas}
                  </div>
                </div>

                <Icon
                  name="sign-out"
                  style={{
                    color:
                      "#f2711c",
                    fontSize: 22,
                  }}
                />
              </div>
            </Segment>
          </div>
        )}

        {/* =====================================
            RESULTADOS
        ===================================== */}

        <Segment
          style={{
            padding: 0,
            borderRadius: 8,
            border:
              "1px solid #e5e9ef",
            boxShadow:
              "0 1px 3px rgba(9,30,66,0.08)",
            overflow: "hidden",
          }}
        >
          {/* HEADER */}

          <div
            style={{
              padding: "13px 17px",
              borderBottom:
                "1px solid #e5e9ef",
              display: "flex",
              justifyContent:
                "space-between",
              alignItems: "center",
              gap: 10,
              flexWrap: "wrap",
              background: "#fff",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                color: "#253858",
                fontWeight: 700,
              }}
            >
              <Icon
                name="list alternate outline"
                style={{
                  color: "#2185d0",
                }}
              />

              Movimientos del paciente
            </div>

            <Label
              basic
              size="small"
              style={{
                margin: 0,
                color: "#6b778c",
              }}
            >
              Total:{" "}
              <strong>
                {merges.length}
              </strong>
            </Label>
          </div>

          {/* LOADING */}

          {loadingMovimientos && (
            <div
              style={{
                padding:
                  "14px 16px 0",
              }}
            >
              <Message
                icon
                info
                size="small"
              >
                <Icon
                  name="spinner"
                  loading
                />

                <Message.Content>
                  <Message.Header>
                    Cargando historial
                  </Message.Header>

                  Consultando entradas,
                  salidas y traspasos del
                  paciente.
                </Message.Content>
              </Message>
            </div>
          )}

          {/* TABLA */}

          {renderTabla()}

          {/* FOOTER */}

          <div
            style={{
              padding: "10px 16px",
              background: "#fbfcfd",
              borderTop:
                "1px solid #e5e9ef",
              color: "#8793a5",
              fontSize: 11,
              display: "flex",
              justifyContent:
                "space-between",
              alignItems: "center",
              gap: 10,
              flexWrap: "wrap",
            }}
          >
            <span>
              Perspectiva logística del
              paciente
            </span>

            <span>
              {merges.length} registro(s)
            </span>
          </div>
        </Segment>

        {/* =====================================
            ALERTA
        ===================================== */}

        <Alerta
          tipo={alerta.tipo}
          mensaje={alerta.mensaje}
          estadoAlerta={
            estadoAlerta
          }
          cambiarEstadoAlerta={
            cambiarEstadoAlerta
          }
        />
      </Container>
    </div>
  );
};

export default Reporte3;